(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteGlobal', ReporteGlobal);

    ReporteGlobal.$inject = ['$resource'];

    function ReporteGlobal ($resource) {

        var resourceUrl =  'apo/reporteglobal:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'downl': { 
            	url:'apo/reporteglobal',
            	method: 'POST',
            	headers: {
                    accept: 'application/octet-stream' 
                },
                responseType: 'arraybuffer',
                cache: false,
            	transformResponse: function (data,headers) {
            		var fileName = getFileNameFromHeader(headers('content-disposition'));
	                if (data && fileName != null) {
	                    let blob = new Blob([data], { 
	                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
	                    }),
	                    objectUrl = URL.createObjectURL(blob);
	                    let a = document.createElement('a');
	                    a.href = objectUrl;
	                    a.download = fileName;
	                    a.target = '_blank';
	                    a.click();
	                }
                    return data;
                }
            }
        });
        
        function getFileNameFromHeader(header){
            if (!header) return null;

            var result = header.split(";")[1].trim().split("=")[1];

            return result.replace(/"/g, '');
        }
        
    }
})();
